import { gsap } from 'gsap';
import { Draggable } from 'gsap/dist/Draggable';
import { ScrollSmoother } from 'gsap/dist/ScrollSmoother';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { SplitText } from 'gsap/dist/SplitText';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, Draggable);

let refreshTimeout: ReturnType<typeof setTimeout> | null = null;

/**
 * Debounced `ScrollTrigger.refresh()`. Elements inside a `content-visibility: auto`
 * container (see `LazySection`) get real layout only once they become "relevant" -
 * ScrollTrigger measurements (pin-spacers, trigger offsets) done before that are
 * wrong, so every consumer that becomes relevant should schedule a refresh.
 * Debouncing coalesces bursts of sections becoming relevant close together
 * (fast scroll, resize) into a single recalculation.
 */
export const scheduleScrollTriggerRefresh = (delay = 100) => {
	if (refreshTimeout) clearTimeout(refreshTimeout);

	refreshTimeout = setTimeout(() => {
		refreshTimeout = null;
		ScrollTrigger.refresh();
	}, delay);
};

export { Draggable, gsap, ScrollSmoother, ScrollTrigger, SplitText };
